import { withInstall, withInstallDirective } from '@lit-element/utils'

import Popover from './src/popover.vue'
import PopoverDirective, { VPopover } from './src/directive'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtPopoverDirective: SFCWithInstall<typeof PopoverDirective> =
  withInstallDirective(PopoverDirective, VPopover)

export const LtPopover: SFCWithInstall<typeof Popover> & {
  directive: typeof LtPopoverDirective
} = withInstall(Popover, {
  directive: LtPopoverDirective,
})
export default LtPopover

export * from './src/popover'
